@use '../../styles/util' as *;
@use '../../styles/global' as *;

:host {
  --options-max-height: 170px;
}

.sol-search-input__container {
  @extend %data-value;

  color: var(--text-base-subdued);
  text-align: left;
  user-select: none;
}

.sol-search-input__label {
  @extend %data-label;

  color: var(--text-base-subdued);
  font-style: normal;
}

.sol-search-input__has-label-space {
  margin: 8px 0;
}

.sol-search-input {
  @extend %data-value;

  display: inline-flex;
  overflow: hidden;
  width: 100%;
  min-width: fit-content;
  height: 42px;
  align-items: center;
  align-self: stretch;
  border: 1px solid transparent;
  border-radius: 3px;
  outline: none;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sol-search-input input {
  z-index: 10;
  width: 100%;
  box-sizing: border-box;
  padding: 0 16px;
  border-width: 0;
  margin-top: 2px;
  background-color: transparent;
  color: var(--text-base-subdued);
  outline-width: 0;
}

.sol-search-input__container-input-unfilled {
  @include base-layer(var(--surface-base-secondary-alpha));

  border: 1px solid transparent;
}

.sol-search-input__container-input-unfilled > input::placeholder {
  color: var(--text-utilities-placeholder);
}

.sol-search-input__container-input-unfilled:focus span,
.sol-search-input__container-input-unfilled:focus > input::placeholder {
  color: var(--text-interaction-default);
}

.sol-search-input__container-input-unfilled.sol-search-input__container-input--is-opaque {
  @include base-layer(var(--surface-base-secondary));
}

.sol-search-input__container-input-unfilled:hover::before {
  @include before-layer(var(--surface-utilities-overlays-hover));
}

.sol-search-input__container-input-unfilled:active::before {
  @include before-layer(var(--surface-utilities-overlays-pressed));
}

.sol-search-input__container-input-unfilled:focus {
  border: 1px solid var(--stroke-interaction);
}

.sol-search-input__container-input-unfilled:focus-within {
  border: 1px solid var(--stroke-interaction);
  background-color: var(--surface-base-default);
}

.sol-search-input__container-input-unfilled:focus-within > input::placeholder {
  color: var(--stroke-interaction);
}

.sol-search-input__container-input-filled {
  @include base-layer(var(--surface-utilities-overlays-off));

  border: 1px solid var(--stroke-default);
}

.sol-search-input__container-input-filled.sol-search-input__container-input--is-opaque {
  @include base-layer(var(--surface-base-default));
}

.sol-search-input__container-input-filled:hover::before {
  @include before-layer(var(--surface-utilities-overlays-hover));
}

.sol-search-input__container-input-filled:active::before {
  @include before-layer(var(--surface-utilities-overlays-pressed));
}

.sol-search-input__list-container {
  position: fixed;
  z-index: 20;
  display: flex;
  overflow: auto;
  width: auto;
  max-height: var(--options-max-height, 0);
  flex-direction: column;
  align-items: flex-start;
  padding: 8px 0;
  border-radius: 3px;
  background: var(--surface-base-default);
  box-shadow:
    0 6px 40px 0 rgb(1 21 28 / 6%),
    0 3px 4px 0 rgb(1 21 28 / 5%);
  color: var(--text-base-subdued);
}

.sol-search-input__list-content {
  width: 100%;
}

.sol-search-input__list-item {
  @include base-layer(inherit);

  display: flex;
  align-items: center;
  align-self: stretch;
  justify-content: space-between;
  padding: 4px 16px;
}

.sol-search-input__list-text {
  @extend %body;

  z-index: 2;
  overflow: hidden;
  color: var(--text-base-default);
  font-style: normal;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sol-search-input__list-item:hover::before {
  @include before-layer(var(--surface-base-secondary-subdued));

  cursor: pointer;
}

.sol-search-input__container-input--disabled,
.sol-search-input__container-input--disabled:hover,
.sol-search-input__container-input--disabled:active {
  background: var(--surface-utilities-disabled);
  color: var(--text-utilities-disabled);
}

.sol-search-input__container-input--disabled > input::placeholder {
  color: var(--text-utilities-disabled);
}

.sol-search-input__container-input--disabled:hover::before,
.sol-search-input__container-input--disabled:active::before {
  background: transparent;
}

.sol-search-input__has-icon-left {
  margin-left: 12px;
}

.sol-search-input__has-icon-right {
  margin-right: 12px;
}
